import { Box, Button, Typography } from '@mui/material';

export type LiveJudgementChoice = 'correct' | 'wrong' | 'uncertain' | 'neutral';

export function judgementToApiValue(
  choice: LiveJudgementChoice | null,
): 'correct' | 'wrong' | 'uncertain' | null {
  if (!choice || choice === 'neutral') return null;
  return choice;
}

const JUDGEMENT_OPTIONS: Array<{
  value: LiveJudgementChoice;
  label: string;
  color: string;
  bg: string;
  border: string;
  hoverBg: string;
}> = [
  {
    value: 'correct',
    label: '正確',
    color: '#fff',
    bg: '#2e7d32',
    border: '#1b5e20',
    hoverBg: '#388e3c',
  },
  {
    value: 'wrong',
    label: '錯誤',
    color: '#fff',
    bg: '#c62828',
    border: '#b71c1c',
    hoverBg: '#d32f2f',
  },
  {
    value: 'neutral',
    label: 'Missing',
    color: '#fff',
    bg: '#ef6c00',
    border: '#e65100',
    hoverBg: '#f57c00',
  },
  {
    value: 'uncertain',
    label: '灰色',
    color: '#fff',
    bg: '#546e7a',
    border: '#455a64',
    hoverBg: '#607d8b',
  },
];

export function getJudgementLabel(choice: LiveJudgementChoice): string {
  return JUDGEMENT_OPTIONS.find((o) => o.value === choice)?.label ?? choice;
}

interface Props {
  onSelect: (value: LiveJudgementChoice) => void;
  inverted?: boolean;
}

export default function LiveJudgementBar({ onSelect, inverted = false }: Props) {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="subtitle2"
        textAlign="center"
        sx={{
          display: 'block',
          mb: 1.25,
          fontWeight: 800,
          color: inverted ? 'rgba(255,255,255,0.75)' : 'text.secondary',
        }}
      >
        步驟 1 · 判決評價
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(4, minmax(0, 1fr))' },
          gap: 1.25,
          width: '100%',
        }}
      >
        {JUDGEMENT_OPTIONS.map((option) => (
          <Button
            key={option.value}
            variant="contained"
            onClick={() => onSelect(option.value)}
            sx={{
              minHeight: { xs: 76, sm: 84 },
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 800,
              fontSize: { xs: '1.15rem', sm: '1.25rem' },
              letterSpacing: 0.5,
              color: option.color,
              bgcolor: option.bg,
              border: '2px solid',
              borderColor: option.border,
              boxShadow: inverted ? '0 4px 14px rgba(0,0,0,0.35)' : 2,
              '&:hover': {
                bgcolor: option.hoverBg,
                borderColor: option.border,
              },
            }}
          >
            {option.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
